import { AttachmentsDataScope } from '../types';

export function getAttachmentStoreScope(scope: AttachmentsDataScope, id: number | null): string {
  return JSON.stringify({ scope, id });
}
